import styled from '@emotion/styled';

export const StyledChatInputWrapper = styled.div`
    margin: 12px 24px;
    flex-grow: 1;
`;

export const StyledReferenceBanner = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: #f3eeff;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #e0d4f5;
    font-size: 13px;
    color: #5b21b6;
    font-weight: 600;
`;

export const StyledReferenceDismiss = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: #9ca3af;
    padding: 0;
    margin-left: auto;
    font-size: 16px;
    line-height: 1;

    &:hover {
        color: #6b7280;
    }
`;

export const StyledChatInputField = styled.div`
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    background: #fcfaff;
    height: fit-content;
    border-radius: 4px;
    padding: 12px 20px;
    min-height: 40px;
    display: flex;
`;

export const StyledInputField = styled.textarea`
    background: inherit;
    margin-right: 8px;
    max-height: 150px;
    overflow-y: auto;
    resize: none;
    width: 100%;
    height: 24px; //keep the same size as for input
    &:hover,
    &:active,
    &:focus {
        outline: none;
    }
`;
